import React, { useEffect, useState } from "react";
import "./ContactCard.css";
import { Avatar } from "@material-ui/core";
import { useContext } from "react";
import { ChatContext } from "../../../contexts/ChatContext";
import { Badge, Box, Typography, alpha } from "@mui/material";
import LetterAvatars from "../../Avatar";
import { socket } from "../Socket/Socket";
import { capitalize } from 'lodash';
import ChatServices from "../../../services/ChatServices";
import VideoContext from "../../../contexts/VideoContext";

const ContactCard = ({ contact, archive, index, isHighlighted = false }) => {

  const { setSelectedContactId, setShowFilePage, setSelectedGroupId, setDeleteGroupId, userId, setSelectedContactChat, setSelectedInboxId, setColorIndex } = useContext(ChatContext);

  const { setIdToCall } = useContext(VideoContext);

  const [unreadMessagesCount, setUnreadMessagesCount] = useState(contact.unreadCount);

  const [isDarkMode, setIsDarkMode] = useState(false);
  
  useEffect(() => {
    const updateTheme = () => {
      const theme = localStorage.getItem('ThemeSwitch');
      setIsDarkMode(theme === 'true');
    };
    updateTheme();
    window.addEventListener('storage', updateTheme);
    const originalSetItem = localStorage.setItem;
    localStorage.setItem = function (key, value) {
      originalSetItem.apply(this, arguments);
      if (key === 'ThemeSwitch') {
        updateTheme();
      }
    };
    return () => {
      window.removeEventListener('storage', updateTheme);
      localStorage.setItem = originalSetItem;
    };
  }, []);

  const openChat = (id) => {
    setSelectedContactId(id);
    setSelectedContactChat(contact);
    setSelectedInboxId(contact._id);
    setColorIndex(index);
    setShowFilePage(false);
    setSelectedGroupId(null);
    socket.emit('join_personal_room', { senderUserId: userId, receiverUserId: id });
    fetchunReadMsg(id);
    setDeleteGroupId(null);
  };

  const fetchunReadMsg = async (id) => {
    try {
      const response = await ChatServices.markReadMsg(userId, id);
      if (response.status === 200) {
        setUnreadMessagesCount(0);
      } else {
        console.error("Error Opening Chat:", response.message);
      }
    } catch (error) {
      console.error("Error calling backend API:", error.message);
    }
  }

  // Determine background color based on highlight, unread count, and dark mode
  const getBackgroundColor = () => {
    if (isHighlighted) {
      return alpha("#667eea", 0.15);
    }
    if (isDarkMode) {
      return unreadMessagesCount === 0 ? "#2a2a2a" : "#1e3a5f";
    }
    return unreadMessagesCount === 0 ? '#d9dae2' : '#B4D4FF';
  };

  return (
    <div 
      className={`contactcard${archive !== '' ? archive : ''}`} 
      style={{ 
        backgroundColor: getBackgroundColor(),
        padding: '8px 12px',
        margin: 0,
        cursor: 'pointer',
        transition: 'all 0.2s ease',
        borderLeft: isHighlighted ? '4px solid #667eea' : '4px solid transparent',
        borderRadius: '8px',
      }} 
      onClick={() => openChat(contact.userId)}
    >
      <Box display='flex' flexDirection='row' alignItems='center' justifyContent='space-between'>
        <Box display='flex' flexDirection='row' alignItems='center' gap={2}>
          <LetterAvatars name={contact.name} status={contact.status} />
          <div className="contactcard__username">
            <h3 style={{ 
              margin: 0, 
              fontSize: '1rem', 
              fontWeight: isHighlighted ? 600 : 500,
              color: isDarkMode ? '#fff' : '#1a1a1a'
            }}>
              {capitalize(contact.name)}
            </h3>
            {contact.lastMessage && (
              <Typography 
                variant="caption" 
                sx={{ 
                  color: isDarkMode ? 'rgba(255,255,255,0.6)' : 'text.secondary',
                  display: 'block',
                  fontSize: '0.75rem',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  maxWidth: '180px'
                }}
              >
                {contact.lastMessage.length > 30 
                  ? contact.lastMessage.substring(0, 30) + '...' 
                  : contact.lastMessage}
              </Typography>
            )}
          </div>
        </Box>
        <Box display='flex' flexDirection='column' alignItems='flex-end' gap={0.5}>
          {contact.timestamp && (
            <Typography variant="caption" sx={{ color: isDarkMode ? 'rgba(255,255,255,0.5)' : 'text.disabled', fontSize: '0.7rem' }}>
              {new Date(contact.timestamp).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
            </Typography>
          )}
          {unreadMessagesCount > 0 && (
            <Badge 
              color="primary" 
              badgeContent={unreadMessagesCount} 
              max={999}
              sx={{
                '& .MuiBadge-badge': {
                  backgroundColor: '#1976d2',
                  color: 'white',
                  fontWeight: 'bold',
                  fontSize: '0.7rem',
                  height: '18px',
                  minWidth: '18px',
                  borderRadius: '9px',
                }
              }}
            />
          )}
        </Box>
      </Box>
    </div>
  );
};

export default ContactCard;
